import styled from "@emotion/styled";
import { neutralDark40, toRgba } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";

const darkSeparatorColor = toRgba(neutralDark40, 0.12);

export const StyledModalActionSeparator = styled("div")`
    background-color: ${darkSeparatorColor};
    width: 2px;
    height: ${sizes.large}px;
`;
